import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 25px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const ImportantNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: stretch;
`;

export const InfoIconStyled = muiStyled(InfoOutlined)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
}));

export const InfoTypography = muiStyled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
}));

export const ImportantLabel = muiStyled("span")({
  fontWeight: 500,
});

export const EmptyStateTypography = muiStyled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
